import type { ShipmentLogbookComment } from 'common/src/api/shipment-logbook';
import type { MarketCommentAttachment } from 'common/src/utils/types';

export const localCalendarDate = (now = new Date()) =>
  `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
export interface LogbookEntry {
  key: string;
  kind: 'note' | 'price';
  at: string;
  author: string;
  notes: string[];
  photos: MarketCommentAttachment[];
  products: ShipmentLogbookComment[];
}
export const groupShipmentLogbook = (
  comments: ShipmentLogbookComment[]
): LogbookEntry[] => {
  const groups = new Map<string, LogbookEntry>();
  for (const c of comments) {
    const key = c.capture_id ? `capture:${c.capture_id}` : `comment:${c.id}`;
    let entry = groups.get(key);
    const actor =
      c.editor || (typeof c.created_by === 'object' ? c.created_by : null);
    const author = [actor?.first_name, actor?.last_name]
      .filter(Boolean)
      .join(' ');
    const at = c.updated_at || c.created_at;
    if (!entry) {
      entry = {
        key,
        kind: c.unit_price != null ? 'price' : 'note',
        at,
        author,
        notes: [],
        photos: [],
        products: [],
      };
      groups.set(key, entry);
    }
    if (at > entry.at) {
      entry.at = at;
      entry.author = author;
    }
    if (c.content?.trim() && !entry.notes.includes(c.content.trim()))
      entry.notes.push(c.content.trim());
    if (c.unit_price != null) entry.products.push(c);
    for (const photo of c.attachments || []) {
      if (photo.deleted_at || !photo.is_image) continue;
      const identity = (p: MarketCommentAttachment) =>
        p.checksum ? `sha:${p.checksum}` : `${p.bucket}/${p.path}`;
      if (!entry.photos.some((p) => identity(p) === identity(photo)))
        entry.photos.push(photo);
    }
  }
  return [...groups.values()].sort(
    (a, b) => b.at.localeCompare(a.at) || b.key.localeCompare(a.key)
  );
};
